module.exports = __webpack_public_path__ + "media/images/thumbs-up-fc2381ea.png";